import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { ThemeProvider } from '@/contexts/ThemeContext'
import DashboardPage from '@/pages/DashboardPage'
import DocumentationPage from '@/pages/DocumentationPage'
import AccessGate from '@/auth/AccessGate'
import './index.css'

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to="/dashboard" replace />}
      />
      <Route
        path="/dashboard"
        element={<DashboardPage />}
      />
      <Route
        path="/documentation"
        element={<DocumentationPage />}
      />
    </Routes>
  )
}

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <AccessGate>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </AccessGate>
      </Router>
    </ThemeProvider>
  )
}

export default App 